import React, { FC, useEffect, useRef, useState } from 'react';
import Button from '@material-ui/core/Button';
import Dialog, { DialogProps } from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import InfoDialogButtons from '../../components/buttons/InfoDialogButtons';

interface InfoHelpDialogProps {
  open: boolean;
  onClose: () => void;
}

const InfoHelpDialog: FC<InfoHelpDialogProps> = ({ open, onClose }) => {
  const [scroll] = useState<DialogProps['scroll']>('paper');

  const descriptionElementRef = useRef<HTMLElement>(null);

  useEffect(() => {
    if (open) {
      const { current: descriptionElement } = descriptionElementRef;
      if (descriptionElement !== null) {
        descriptionElement.focus();
      }
    }
  }, [open]);

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        scroll={scroll}
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
      >
        <DialogTitle id="scroll-dialog-title">
        <b>Brugervejledning til Infomodul</b>
        </DialogTitle>
        <DialogContent dividers={scroll === 'paper'}>
          <div id="descriptiontext">
            Denne vejledning forklarer, hvordan du tilføjer, ændrer og administrerer billeder på p-automater. Du kan vælge mellem tre typer billeder: "Ude af drift", "Pauseskærm", og "Reklame". Billederne skal redigeres i et billedbehandlingsprogram og overholde de specifikke krav til størrelse og format.
            <br />
              <b>Billedtyper:</b>
            <ul>
              <li>Ude af drift: Vises kontinuerligt, når automaten er sat ud af drift.</li>
              <li>Pauseskærm: Vises efter 15 sekunders inaktivitet, med header og statusbar synlig.</li>
              <li>Reklame: Dækker headeren og viser en "Tryk for parkering"-knap.</li>
            </ul>
            <InfoDialogButtons/>
            <br />
            <b>Vigtig Information</b>
            <ul>
              <li>Billedstørrelser: Sørg for, at billeder overholder de angivne størrelseskrav (se under "Tilføj Billeder til Galleriet").</li>
              <li>Opdateringer: Du kan vælge at opdatere automater straks eller ved midnat, afhængigt af behov.</li>
              <li>Automatstatus: "Ude af drift"-status styres gennem Mobilbasen og skal manuelt ændres der.</li>
            </ul>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} color="primary">
            Luk
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default InfoHelpDialog;
